import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Crop02 = function Crop02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M10 6h4.8c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874C18 7.5198 18 8.08 18 9.2V14M2 6h4m12 12v4m4-4H9.2c-1.1201 0-1.6802 0-2.108-.218a2 2 0 0 1-.874-.874C6 16.4802 6 15.9201 6 14.8V2"
    })
  }));
};
export default Crop02;